var c = this;
// cache dos perfis de usuarios
var userProfiles = [];

var cryo_maskphone = "(99) 99999-9999";
var cryo_mask_cep = "99999-999";

var formAction;

if (!Date.prototype.toISOString) {
    (function () {
        function pad(number) {
            if (number < 10) {
                return '0' + number;
            }
            return number;
        }

        Date.prototype.toISOString = function () {
            return this.getUTCFullYear() +
                '-' + pad(this.getUTCMonth() + 1) +
                '-' + pad(this.getUTCDate()) +
                'T' + pad(this.getUTCHours()) +
                ':' + pad(this.getUTCMinutes()) +
                ':' + pad(this.getUTCSeconds()) +
                '.' + (this.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) +
                'Z';
        };
    }());
}

if (!clientIsMobile) {
    window.onerror = function (message, file, line, col, err) {
        $.ajax({
            type: 'POST',
            url: URL_ROOT + 'api/internal/legacy/1.0/general/error.aspx',
            data: "j=" + JSON.stringify({
                "c": navigator.userAgent,
                "m": message,
                "l": line,
                "col": (col ? col : ""),
                "error": JSON.stringify(err),
                "f": file,
                "location": (window && window.location && window.location.href ? window.location.href : "")
            }),
            dataType: "json",
            success: function (data) {
                if (data.success != null) {
                    if (blnShowFriendlyJsErrors && new RegExp("\/common\/plugins\/signalR\/", "gi").test(file)) {
                        $("#JavascriptError").append("<small> (" + message + ", " + file + ", " + line + ")</small>");
                        $("#JavascriptError").show();
                    }
                }
            },
        });
        return false;
    };
}

function getObj(n) {
    return document.getElementById(n);
}

// Avoid `console` errors in browsers that lack a console.
(function () {
    var method;
    var noop = function () { };
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

$(document).ready(function () {
    //cryo_setPlaceHolder();
    cryo_setMaskDate();
    //cryo_setProfile();
    cryo_setToolTip();
    cryo_setBoxOpenClose();
    cryo_setNotification();
    cryo_setNavbarTargetOnColorbox();
    cryo_setColorbox();

    $.extend($.fn.typeahead.defaults, {
        item: '<li><a href="#" style="padding-right: 50px"></a></li>',
        highlighter: function (item) {
            var query = this.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');

            var $item = $("<div/>").html(item);

            if ($item.children().length > 0)
                return item;

            $item.find(":not(iframe)")
                .addBack()
                .contents()
                .filter(function () {
                    return this.nodeType === 3;
                })
                .each(function () {
                    this.parentNode.innerHTML = this.parentNode.innerHTML.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match) {
                        return '<strong>' + match + '</strong>';
                    });
                });

            return $item.prop("outerHTML");
        }
    });
});

function cryo_setColorbox() {
    $.colorbox.settings.opacity = 0.6;
    $.colorbox.settings.transition = "none";
    $.colorbox.settings.trapFocus = false;
    //$("#cboxContent").addClass("blue_border_example");
    $("#cboxTopLeft").remove();
    $("#cboxTopRight").remove();
    $("#cboxTopCenter").remove();
    $("#cboxBottomCenter").remove();
    $("#cboxBottomLeft").remove();
    $("#cboxBottomRight").remove();
    $("#cboxMiddleRight").remove();
    $("#cboxMiddleLeft").remove();

    $('*').on('click', '[data-colorbox="true"]', function () {
        var $a = $(this);
        var url = '';
        if ($a.attr('querystring') == null)
            url = $a.attr("href");
        else
            url = $a.attr('querystring');

        var w = $a.attr("data-colorbox-width") || "90%";
        var h = $a.attr("data-colorbox-height") || "90%";
        $.colorbox();
        $.colorbox({ href: url, iframe: true, innerWidth: w, innerHeight: h });
        return false;
    });
}

function cryo_confirm(message, title, primaryButtonLabel, okcallback, closeColorbox) {
    if (closeColorbox === undefined) {
        closeColorbox = true;
    }
    const html =
        `<div class="cryo-confirm-dialog">
            <div class="modal-header"><h3>${title}</h3></div>
            <div class="modal-body">${message}</div>
            <div class="modal-footer">
                <button type="button" class="btn btn-link ${(clientIsMobile ? 'btn-large' : '')}" accesskey="${mlLblNoAccessKey}">
                    ${btnCancel} <sup class="shortcut">${mlLblNoAccessKey}</sup>
                </button>
                <button type="button" class="btn btn-primary ${(clientIsMobile ? 'btn-large' : '')}" accesskey="${mlLblYesAccessKey}">
                    ${primaryButtonLabel} <sup class="shortcut">${mlLblYesAccessKey}</sup>
                </button>
            </div>
        </div>`;
    $.colorbox({ closeButton: false, width: (clientIsMobile ? "90%" : "500px"), html: html });
    cryo_UnderlineAccessKey('div.cryo-confirm-dialog', true);
    $(".cryo-confirm-dialog").find(".btn-primary").focus();
    $(".cryo-confirm-dialog").find(".btn-primary").click(function () { if (closeColorbox) { $.colorbox.close(); } okcallback(); });
    $(".cryo-confirm-dialog").find(".btn-link").click(function () { $.colorbox.close(); });
}

function cryo_alert(msg, okcallback) {
    msg = msg.replace(/\n/g, '<br>');
    $.colorbox({ closeButton: false, width: (clientIsMobile ? "90%" : "400px"), html: '<div class="cryo-confirm-dialog padded"><h2>' + mlLblAtention + '!</h2><p>' + msg + '</p><div class="spaced text-right"><button type="button" class="btn btn-success ' + (clientIsMobile ? 'btn-large' : '') + '">OK</button></div></div>' });
    cryo_UnderlineAccessKey('div.cryo-confirm-dialog');
    $(".cryo-confirm-dialog").find(".btn-success").focus();
    $(".cryo-confirm-dialog").find(".btn-success").click(function () { $.colorbox.close(); if (okcallback != null && okcallback != undefined) okcallback(); });
}

function cryo_configTargetPostbackLogout(link) {
    $("form").attr("target", "");
    $("form").attr("action", "");
    cryo_configTargetPostback(link);
}

function cryo_configTargetPostback(link) {
    try {
        if (self != top) {
            if (parent.document) {
                $(link).attr("target", "");
                $("form").attr("target", "_parent");
            }
        }
    } catch (e) {
    }
}
function cryo_setNavbarTargetOnColorbox() {
    if (self != top) {
        $(".navbar a").attr("target", "_parent");
    }
}

function cryo_setNotification() {
    if ($(".notification-box").length > 0) {
        function countNotifications() {
            $.ajax({
                type: "POST",
                url: URL_ROOT + "api/internal/legacy/1.0/inbox/notification.aspx",
                global: false,
                data: "m=count-unread",
                success: function (data) {
                    if (data.success) {
                        var $countbox = $(".notification-count");
                        if (data.success == "0") {
                            $countbox.removeClass("badge-important");
                        } else {
                            $countbox.addClass("badge-important");
                        }
                        $countbox.text(data.success);
                    }
                },
                dataType: "json"
            });
        }

        countNotifications();
        window.setInterval(countNotifications, notificationInterval);

        var notifications = new Array();
        $(".notification-box").mouseover(function () {
            $this = $(this);
            $.ajax({
                type: "POST",
                url: URL_ROOT + "api/internal/legacy/1.0/inbox/notification.aspx",
                global: false,
                data: "m=list&concat=70&top=5",
                success: function (data) {
                    var $ul = $this.closest("li").find("ul");
                    var $li = $ul.find("li:eq(1)");
                    $.each(data, function (i, item) {
                        if (jQuery.inArray(data[i].codnotification, notifications) == -1) {
                            $li.before("<li class=\"notification-item notification-item-" + data[i].codnotification + " " + (data[i].stread == "N" ? " notification-item-unread" : "") + "\"><a href=\"javascript:void(0)\" onclick=\"cryo_notificationSee(this,'" + data[i].codnotificationenc + "')\" class=\"user-small\"><div class=\"user-photo\" style=\"background-image: url(" + data[i].dsphotofrom + ")\"><img src=\"" + data[i].dsphotofrom + "\"></div><div class=\"notification-content\">" + data[i].dssubject + " <span class=\"muted\">" + data[i].dsbody + "</span><div class=\"small\">" + data[i].dtdate + "<i onclick=cryo_notificationMarkRead(this,'" + data[i].codnotificationenc + "') class=\"icon-ok right " + (data[i].stread == "N" ? "" : "hide") + "\" title=\"" + mlNotificationMark + "\"></i></div></div></a></li>");
                            notifications.push(data[i].codnotification);
                        }
                    });
                },
                dataType: "json"
            });
        });
    }
}

function cryo_notificationMarkRead(i, c) {
    $.ajax({
        type: "POST",
        url: URL_ROOT + "api/internal/legacy/1.0/inbox/notification.aspx",
        data: "m=read&n=" + c,
        success: function (data) {
            if (data.success) {
                $(i).closest(".notification-item").removeClass("notification-item-unread");
                $(i).hide();
            }
        },
        dataType: "json"
    });
    event.stopPropagation();
}

function cryo_notificationMarkAll() {
    $.ajax({
        type: "POST",
        url: URL_ROOT + "api/internal/legacy/1.0/inbox/notification.aspx",
        data: "m=read-all",
        success: function (data) {
            if (data.success) {
                $(".icon-ok").closest("li").removeClass("notification-item-unread");
                $(".icon-ok").hide();
            }
        },
        dataType: "json"
    });
}

function cryo_notificationSee(a, c, r) {
    if (r == null) r = true;
    if (r) {
        var li = $(a).closest("li");
        li.removeClass("notification-item-unread");
        li.find("i").hide();
    }
    $.colorbox({ href: URL_ROOT + 'workbase/wnotification.aspx?n=' + c, iframe: true, innerWidth: 700, innerHeight: 540 });
}

function cryo_notificationSend(c) {
    if (c == null) c = "";
    var url = URL_ROOT + "workbase/wnotification.aspx?c=" + c;
    if ($("#inpCodFlowExecute").length > 0 != "") {
        url = url + "&e=" + $("#inpCodFlowExecute").val();
    }
    if ($("#HidIsNotificationPage").length > 0) {
        document.location.href = url;
    } else {
        $.colorbox({ href: url, iframe: true, innerWidth: 700, innerHeight: 540 });
    }
}

function cryo_notificationUnread(n) {
    var li = $(".notification-item-" + n);
    li.addClass("notification-item-unread");
    li.find("i").show();
    $.colorbox.close();
}

function cryo_setBoxOpenClose() {
    $(".box-open-and-close").each(function () {
        var box = $(this);
        var idbox = $(this).attr("id") || "box";

        // 28136: filtro dos relatorios devem aparecer sempre abertos
        if (cryo_readCookie(idbox) === "open" || idbox === 'filter_rel_tracker') {
            box.removeClass("box-closed");
        } else {
            box.addClass("box-closed");
        }

        box.find(".box-header").click(function () {
            if (box.hasClass("box-closed")) {
                box.removeClass("box-closed");
                cryo_writeCookie(idbox, "open");
            } else {
                box.addClass("box-closed");
                cryo_writeCookie(idbox, "closed");
            }
        });
    });
}

function cryo_setMaskDate(tableRow) {
    if (navigator.userAgent.indexOf("MSIE 8") == -1 && navigator.userAgent.indexOf("MSIE 7") == -1) {
        // modern browsers
        $("input[mask='date']").each(function (i, o) {
            if ($.fn.mask) {
                $(o).mask("99/99/9999");
            }
            if ($.fn.datepicker) {
                $(o).datepicker({
                    format: globalDateFormat,
                    language: datepickerLanguage,
                    autoclose: true,
                    forceParse: false
                });
            }
        });
    } else {
        // old browsers
        if (tableRow === undefined) {
            $("input[mask='date']").focus(function (e) {
                return tMask($(this)[0], 'dd/mm/yyyy', true);
            });
        } else {
            $(tableRow).find("input[mask='date']").off('focus').focus(function (e) {
                return tMask($(this)[0], 'dd/mm/yyyy', true);
            });
        }
    }
}

function cryo_setPlaceHolder() {
    $('[placeholder]').focus(function () {
        var input = $(this);
        if (input.val() == input.attr('placeholder')) {
            input.val('');
            input.removeClass('placeholder');
        }
    }).blur(function () {
        var input = $(this);
        if (input.val() == '' || input.val() == input.attr('placeholder')) {
            input.addClass('placeholder');
            input.val(input.attr('placeholder'));
        }
    }).blur();
}

function cryo_setProfile() {
    $("span[rel='popover']").each(function () {
        $(this).hover(function () {
            // mouseover
            var el = $(this);
            var key = el.attr("userid");
            var htmlContent = '';
            //el.unbind('hover');

            // pesquisa no cache
            $.each(userProfiles, function (i, o) {
                if (o.key == key) {
                    htmlContent = o.html;
                }
            });

            if (htmlContent == '') {
                // nao tem em cache deve requisitar
                $.ajax({
                    url: URL_ROOT + "api/internal/legacy/1.0/user/profile.aspx?c=" + key,
                    async: false,
                    success: function (d) {
                        userProfiles.push({ key: key, html: d });
                        htmlContent = d;
                    }
                });
            }

            if (htmlContent != '') {
                // encontrou o perfil, deve exibir o popover
                el.popover({
                    html: true,
                    content: htmlContent
                }).popover('show');
            }
        }, function () {
            // mouseout
            $(this).popover('hide');
            $('div.popover').hide();
        });
    });
}

var cryo_searchuser_cod, cryo_searchuser_text;
function cryo_setSearchUser(cod, text) {
    cryo_searchuser_cod = cod;
    cryo_searchuser_text = text;
    function _openUserSearch() {
        $.colorbox({ href: URL_ROOT + 'workflow/wffinduser.aspx?inpSearch=' + text.val(), iframe: true, innerWidth: 700, innerHeight: 400 });
    }
    text.addClass("search");

    text.keyup(function (e) {
        var code = e.keyCode || e.which;
        if (!(code == 8 || code == 46)) {//not backspace or delete
            _openUserSearch();
        }
    });
    text.change(function () {
        if ($(this).val() == "") {
            cod.val("");
        }
    });
    text.parent().find("a").click(function () {
        _openUserSearch();
    });
}
function cryo_searchUserCallBack(cod, text) {
    cryo_searchuser_cod.val(cod);
    cryo_searchuser_text.val(text);
}

function cryo_cryptPass(p) {
    $("#inpToCrypt").val(1);
}

function cryo_setAreaHierarchy(cod, text, mode) {
    text.addClass("search");
    text.focus(function (e) {
        // Leonardo - 13/02/2013 - Abrir caixa de pesquisa de areas ao colocar foco no campo.
        cryo_openAreaHierarchy(mode);
    });
    text.keyup(function (e) {
        var code = e.keyCode || e.which;
        if (!(code == 8 || code == 46)) {//not backspace or delete
            cryo_openAreaHierarchy(mode);
        }
    });
    text.change(function () {
        if ($(this).val() == "") {
            cod.val("");
        }
    });
    text.parent().find("a").click(function () {
        cryo_openAreaHierarchy(mode);
    });
}

function cryo_openAreaHierarchy(mode, parentObj) {
    var url;

    if (mode == null) mode = "readonly";

    url = URL_ROOT + 'workflow/wfarea_hierarchy.aspx?mode=' + mode + "&rnd=" + parseInt(Math.random() * 1000, 10);

    if (parentObj !== undefined) {
        parentObj.$.colorbox({ href: url, iframe: true, innerWidth: $(parentObj).width() * 0.8, innerHeight: $(parentObj).height() * 0.8 });
    } else {
        $.colorbox({ href: url, iframe: true, innerWidth: $(window).width() * 0.8, innerHeight: $(window).height() * 0.8 });
    }
}

function cryo_setPositionHierarchy(cod, text, mode) {
    text.addClass("search");
    text.focus(function (e) {
        // Leonardo - 13/02/2013 - Abrir caixa de pesquisa de areas ao colocar foco no campo.
        cryo_openPositionHierarchy(mode);
    });
    text.keyup(function (e) {
        var code = e.keyCode || e.which;
        if (!(code == 8 || code == 46)) {//not backspace or delete
            cryo_openPositionHierarchy(mode);
        }
    });
    text.change(function () {
        if ($(this).val() == "") {
            cod.val("");
        }
    });
    text.parent().find("a").click(function () {
        cryo_openPositionHierarchy(mode);
    });
}

function cryo_openPositionHierarchy(mode, codarea, parentObj) {
    if (mode == null) mode = "readonly";
    if (codarea == null) codarea = "";
    if (parentObj) {
        parentObj.$.colorbox({ href: URL_ROOT + 'workflow/wfposition_hierarchy.aspx?mode=' + mode + "&inpCodArea=" + codarea, iframe: true, innerWidth: $(parentObj).width() * 0.8, innerHeight: $(parentObj).height() * 0.8 });
    } else {
        $.colorbox({ href: URL_ROOT + 'workflow/wfposition_hierarchy.aspx?mode=' + mode + "&inpCodArea=" + codarea, iframe: true, innerWidth: $(window).width() * 0.8, innerHeight: $(window).height() * 0.8 });
    }
}

function openModalPositionHierarchy(mode, codarea, parent) {
    if (mode == null) mode = "readonly";
    if (codarea == null) codarea = "";
    const url = URL_ROOT + 'workflow/wfposition_hierarchy.aspx?mode=' + mode + "&inpCodArea=" + codarea + "&rnd=" + parseInt(Math.random() * 1000, 10);
    if (parent)
        parent.bsml.modalOpen(url, 4);
    else
        window.bsml.modalOpen(url, 4);
}

function openModalAreaHierarchy(mode, parent) {
    if (mode == null) mode = "readonly";
    const url = URL_ROOT + 'workflow/wfarea_hierarchy.aspx?mode=' + mode + "&rnd=" + parseInt(Math.random() * 1000, 10);
    if (parent)
        parent.bsml.modalOpen(url, 4);
    else
        window.bsml.modalOpen(url, 4);
}

function cryo_Upload(folder, comment, requester) {
    if (comment == null) comment = "0";
    if (requester == null) requester = "0";
    $.colorbox({ href: URL_ROOT + 'workbase/wupload.aspx?inpDsFolder=' + folder + "&inpShowComment=" + comment + "&inpShowRequesterCheck=" + requester, iframe: true, innerWidth: "90%", innerHeight: "80%" });
}

function cryo_UploadCrypt(c, button) {
    var rowIndex = -1;

    if (button && isInsideMultipleValueTable(button)) {
        let tr = getParentByFilter(button, function (p) {
            return p.nodeName.toLowerCase() === "tr";
        })
        let linesWithDocumentViewer = [...button.closest('tbody').querySelectorAll('tr:not(.header)')].slice(0, tr.rowIndex).filter((i) => i.querySelector('div[id^=divDocContent_]')).length
        rowIndex = tr.rowIndex - linesWithDocumentViewer;
    }
    try {
        var close_modal = parent.document.querySelector('.modal-close');

        // Verifica se já tem um X para fechar o modal anterior e escondee ele para que não crie uma confusão no usuário e acabe fechando a tela errada.
        if (close_modal != null && close_modal.offsetParent !== null) {
            close_modal.style.display = "none";

            var show_close_modal_function = function () { close_modal.style.display = "block"; };
            $('#cboxOverlay').one("click", show_close_modal_function);
        }
    } catch (e) {
        //Evitar erro de CORS
        let content = window;
        content.parent.postMessage("hide-modal-close", "*");
        var show_close_modal_function = function () {
            let content = window;
            content.parent.postMessage("show-modal-close", "*")
        };
        $('#cboxOverlay').one("click", show_close_modal_function);
        $('#cboxClose').one("click", show_close_modal_function);
    }

    $.colorbox({ href: URL_ROOT + 'workbase/wupload.aspx?i=' + (rowIndex - 1) + '&c=' + c, iframe: true, innerWidth: "90%", innerHeight: "90%", scrolling: true });
}

function cryo_openChangeUser() {
    $.colorbox({ href: URL_ROOT + "workbase/wuser_change.aspx", iframe: true, innerWidth: 700, innerHeight: 400 });
}

function cryo_helpOnline(help, uid) { //v4.0
    var codHelpUID = getObj("inpCodHelpUID");
    if (uid != null) {
        help += "?StepUID={" + uid + "}";
    } else if (codHelpUID && codHelpUID.value && codHelpUID.value != "") {
        help += "?StepUID={" + codHelpUID.value + "}";
    }
    window.open(help, "HelpOnline");
}

function cryo_getTopFrame(init) {
    if (init == null) init = self;
    var found = false;
    var frame = init;
    if (frame != null && frame != top) {
        try {
            while (!found) {
                if (frame != top
                    && frame.parent != null
                    && frame.parent.document != null
                    && frame.location != frame.parent.location) {
                    frame = frame.parent;
                } else {
                    found = true;
                }
            }
        } catch (e) { found = true; }
    }
    return frame;
}

function cryo_pop(url, e, onLoad) {
    if (e != null) {
        e.returnValue = false;
        e.cancel = true;
    }
    if (typeof url === 'object') url = $(url).attr("data-href") != "" ? $(url).attr("data-href") : $(url).attr("href");
    if (e != null) e = e || window.event;
    var frame = cryo_getTopFrame();
    if (
        (clientIsMobile
            || true) // blnOpenTasksInColorBox
        && (
            (e == null || !e.ctrlKey)
            && (url.toLowerCase().indexOf('wfflow_execute.aspx') >= 0
                || url.toLowerCase().indexOf('wfrel_tracker_detail.aspx') >= 0
                || url.toLowerCase().indexOf('readonly.aspx') >= 0)
            && frame == top
        )
    ) {
        // Por padrão irá manter sempre o frame.$ que é como funcionava anteriormente
        var $frame = frame.$;

        // Novas págignas como /report abre o detalhe do relatório ainda no modo antigo mas não possui o frame.$, então nesse caso utilizando o jquery de dentro do próprio detalhe para chamar a função
        // Removendo assim a necessidade de ter que inserir os arquivos de jquery na página anterior
        if (!$frame || frame.frames.length > 0 && frame.frames[0].document.querySelector('.cboxIframe') != null) {
            // a tela do relatorio não tinha o frame zero quando era aberta via modal/colorbox
            $frame = (frame.frames[0].$ || frame.frames[1].$);
        }

        $frame('#cboxLoadingGraphic').show();

        if (window.parent.location.href.includes('design') && !url.includes('workflow')) {
            var pathArray = location.pathname.split('/');
            var appPath = "/";
            for (var i = 1; i < pathArray.length - 1; i++) {
                appPath += pathArray[i] + "/";
            }
            url = appPath + url;
        }

        $frame.colorbox({
            href: url,
            iframe: true,
            innerWidth: (clientIsMobile ? "99%" : "90%"),
            innerHeight: (clientIsMobile ? "96%" : "90%"),
            fastIframe: false,
            onComplete: function () {
                $frame("body").css("overflow-y", "hidden");
                $frame(".default").css("margin-right", "17px");
            },
            onClosed: function () {
                $frame("body").css("overflow-y", "scroll");
                $frame(".default").css("margin-right", "0px");
            },
            onLoad: onLoad
        });
    } else {
        window.open(url);
    }
    return false;
}

function closeBpmModal() {
    if (!cryo_isInIframe()) {
        window.self.close();
    } else {
        var element = new parent.Modal(parent.document.getElementById('dynmodal'))
        element.hide();
    }
}

function cryo_popClose(cod) {
    if (!cryo_isInIframe()) {
        window.self.close();
    } else if (parent) {
        try {
            parent.$.colorbox.close();
        } catch (e) {
            window.self.close();
        }
    } else {
        window.self.close();
    }
}

function cryo_isInIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

function cryo_searchUser(o, u) {
    $.colorbox({ href: URL_ROOT + 'workflow/wffinduser.aspx', iframe: true, innerWidth: 700, innerHeight: 400 });
}

/*tooltip customizado devido a bug de posicionamento do bootstrap*/
function cryo_setToolTip() {
    $("[rel='tooltip']").each(function () {
        $(this).mouseover(function (e) {
            cryo_showTooltip(this, e, $(this).attr("data-original-title"), $(this).attr("data-placement"));
        });
    });
}

function cryo_showTooltip(what, e, content, pos, w) {
    var chkShowtooltip = document.getElementById("inpChkShowtooltip");
    var parentChkShowtooltip = parent.parent.document.getElementById("inpChkShowtooltip");

    if (pos == null) pos = "left";
    if (w == null) w = 200;

    var tooltipbox = $(".tooltip")[0];
    var tooltipcontent = $(".tooltip-content")[0];

    tooltipcontent.innerHTML = content;

    tooltipbox.style.display = "block";

    if (pos == 'bottom') {
        $(tooltipbox).addClass("bottom");
        tooltipbox.style.left = num(cryo_getposOffsetToTooltip(what, "left")) + 5 + "px";
        tooltipbox.style.top = num(cryo_getposOffsetToTooltip(what, "top")) + num(what.offsetHeight) + 5 + "px";
    } else {
        $(tooltipbox).addClass("left");
        tooltipbox.style.left = num(cryo_getposOffsetToTooltip(what, "left")) + num(what.offsetWidth) + 5 + "px";
        tooltipbox.style.top = num(cryo_getposOffsetToTooltip(what, "top")) + 5 + "px";
    }

    tooltipbox.style.width = w + "px";

    if ((num(tooltipbox.style.left) + num(tooltipbox.clientWidth)) > num(windowVisibleWidth())) {
        tooltipbox.style.left = num(cryo_getposOffsetToTooltip(what, "left")) + num(what.offsetWidth) - num(tooltipbox.clientWidth) - 5 + "px";
        $(tooltipbox).addClass("bottom-inverse");
    }

    what.onmouseout = function () {
        $(tooltipbox).removeClass("right");
        $(tooltipbox).removeClass("left");
        $(tooltipbox).removeClass("bottom");
        $(tooltipbox).removeClass("bottom-inverse");
        tooltipbox.style.display = "none";
    };
}

function cryo_getposOffsetToTooltip(what, offsettype) {
    var totaloffset = (offsettype == "left") ? what.offsetLeft : what.offsetTop;
    var parentEl = what.offsetParent;
    while (parentEl != null) {
        totaloffset = (offsettype == "left") ? totaloffset + parentEl.offsetLeft : totaloffset + parentEl.offsetTop - parentEl.scrollTop;
        parentEl = parentEl.offsetParent;
    }
    return totaloffset;
}

function cryo_configTypehead(name, cod, activeonly, forceallusers, onSelectCallback, clearIfNoneFound) {
    if (activeonly == null) activeonly = false;
    if (forceallusers == null) forceallusers = false;
    $('#' + name)
        .attr('autocomplete', 'off')
        .blur(function () {
            if ($('#' + cod).val() == "")
                $(this).val("");

            if ($(this).val() == "")
                $('#' + cod).val("");
        })
        .typeahead(
            {
                minLength: 3,
                source: function source(query, process) {
                    $('ul.typeahead').css('z-index', '9999');
                    $.ajax({
                        url: URL_ROOT + 'api/internal/legacy/1.0/user/usernames.aspx',
                        dataType: 'json',
                        async: true,
                        data: 'includeCode=1&forceAllUsers=' + (forceallusers ? '1' : '0') + '&activeOnly=' + (activeonly ? "1" : "0") + '&inpDsName=*' + query + '*&photo=1',
                        success: function (data) {
                            arrNames = [];
                            arrCodesAndName = [];

                            if (data.success !== undefined) {
                                var noPhoto = URL_ROOT + 'common/images/v3/member.jpg';
                                var template = "";
                                if (!clientIsMobile) {
                                    template = '<div class="user user-small" data-id="{{id}}"><div class="user-photo" style="background-image: url({{img}})"><img src="{{img}}"></div><div class="user-content"><strong class="inline">{{name}}</strong><div class="muted"><span class="hide">{{username}} </span>{{email}}</div></div></div>';
                                } else {
                                    template = '<div class="user" data-id="{{id}}">{{name}}</div>';
                                }
                                $.each(data.success, function (i, o) {
                                    var item = template;

                                    item = item.replace(/\{\{id\}\}/gi, o.CodUser);
                                    if (o.DsPhoto !== '') {
                                        item = item.replace(/\{\{img\}\}/gi, o.DsPhoto);
                                    } else {
                                        item = item.replace(/\{\{img\}\}/gi, noPhoto);
                                    }
                                    item = item.replace('{{name}}', o.DsName);
                                    item = item.replace('{{username}}', o.DsUserName);
                                    item = item.replace('{{email}}', o.DsEmail);

                                    arrNames.push(item);

                                    arrCodesAndName.push({ "code": o.CodUser, "name": o.DsName });
                                });
                            } else {
                                $.each(data, function (i, o) {
                                    var code, name;
                                    if (o.indexOf('___') > -1) {
                                        var info = o.split('___');
                                        name = info[0];
                                        code = info[1];
                                        arrNames.push(name);
                                        arrCodesAndName.push({ "code": code, "name": name });
                                    }
                                });
                            }

                            if (clearIfNoneFound) {
                                $('#' + cod).val("");
                            }

                            process(arrNames);
                        }
                    });
                },
                matcher: function (item) {
                    return true
                },
                updater: function (data) {
                    if (data !== undefined) {
                        if (data.indexOf('<') > -1) {
                            // com foto

                            var dataToHtml = $.parseHTML(data);

                            var div = $(dataToHtml);
                            var code = $(div).attr('data-id');

                            $('#' + cod).val(code);

                            $.each(arrCodesAndName, function (i, o) {
                                if (o.code == code) {
                                    data = o.name.replace(/<(?:.|\n)*?>/gm, '');
                                    $('#' + cod).val(o.code);

                                    if (onSelectCallback !== undefined) {
                                        onSelectCallback();
                                    }
                                }
                            });
                        } else {
                            $.each(arrCodesAndName, function (i, o) {
                                if (o.name == data) {
                                    data = data.replace(/<(?:.|\n)*?>/gm, '');
                                    $('#' + cod).val(o.code);

                                    if (onSelectCallback !== undefined) {
                                        onSelectCallback();
                                    }
                                }
                            });
                        }
                    }
                    return data;
                }
            });
}

function cryo_camelcase(s) {
    s = $.trim(s);

    s = ((/\S[A-Z]/.test(s)) ?
        s.replace(/(.)([A-Z])/g, function (t, a, b) { return a + ' ' + b.toLowerCase(); }) :
        s.replace(/( )([a-z])/g, function (t, a, b) { return b.toUpperCase(); }));

    // remover espacos se ainda houver e retornar
    s = s.replace(/\s+/g, '');

    s = s.substring(0, 1).toLowerCase() + s.substring(1);

    return s;
}

function cryo_url(s) {
    s = $.trim(s);

    s = ((/\S[A-Z]/.test(s)) ?
        s.replace(/(.)([A-Z])/g, function (t, a, b) { return a + '-' + b }) :
        s.replace(/( )([a-z])/g, function (t, a, b) { return '-' + b }));

    // remover espacos se ainda houver e retornar
    s = s.replace(/\s+/g, '-');

    s = s.substring(0, 1).toLowerCase() + s.substring(1);

    return s;
}

function cryo_resizeIFrame(frame, offset, idFrame) {
    try {
        if (offset == null) offset = 0;

        if (frame != null && frame.document != null) {
            var w = frame.document.body.scrollWidth;
            var h = frame.document.body.scrollHeight;

            if (frame.document.body.scrollWidth > frame.document.body.offsetWidth) {
                document.getElementById(frame.name).height = h + offset;
                frame.height = h + offset;
            }
            else {
                document.getElementById(frame.name).height = h + offset;
            }
            document.getElementById(frame.name).setAttribute("scrolling", "no");
        }
    } catch (ex) {
        if (idFrame != null) {
            var frame = document.getElementById(idFrame);
            //Captura o tamanho que sobra sem conteudo na tela e adiciona o valor ao tamanho do frame.
            frame.height = (frame.offsetHeight + (window.innerHeight - document.body.scrollHeight));
        }
    }
}

// retorna valor de propriedade do objeto
// obj - referencia do objeto
// propertyName - nome da propriedade
function cryo_GetObjectPropertyValue(obj, propertyName) {
    if (!obj.attributes) return null;
    if (obj && propertyName) {
        if (window.attachEvent) {
            // IE
            if (obj.getAttribute(propertyName) != null) {
                return obj.getAttribute(propertyName);
            } else {
                return "";
            }
        } else {
            return obj.getAttribute(propertyName);
        }
    }
    return "";
}

function cryo_SetObjectPropertyValue(obj, propertyName, propertyValue) {
    // se objeto nao possui atributos entao retorna null
    if (!obj.attributes) return null;

    // se objeto e propriedade existem
    if (obj && propertyName) {
        if (window.attachEvent) {
            // IE
            obj.setAttribute(propertyName, propertyValue);
        } else {
            // gecko
            obj.setAttribute(propertyName, propertyValue);
        }
    } else {
        return null;
    }
}

function cryo_search(s, c) {
    var url = URL_ROOT + 'workflow/wfrel_tracker.aspx?';

    if (s !== undefined) {
        url = url + 'inpsearch=' + s;
    }
    if (c !== undefined && c !== '') {
        url = url + '&c=' + c;
    }

    location.href = url;
    event.returnValue = false;
    event.cancel = true;
}

function cryo_writeCookie(name, value) {
    var expires = new Date(2500, 12, 31);
    var frame = cryo_getTopFrame();
    frame.document.cookie = name + "=" + escape(value) + "; expires=" + expires.toGMTString();
}

function cryo_readCookie(name) {
    var query = name + "=";
    var frame = cryo_getTopFrame();
    if (frame.document.cookie.length > 0) { // se existir cookies
        offset = frame.document.cookie.indexOf(query);
        if (offset != -1) { // se existe cookie
            offset += query.length;
            // index = comeco do valor
            end = frame.document.cookie.indexOf(";", offset);
            // index = fim do valor
            if (end == -1) {
                end = frame.document.cookie.length;
            }
            return unescape(frame.document.cookie.substring(offset, end));
        }
    }
}

function cryo_mdc(o) {
    if (!o.length)
        return 0;
    for (var r, a, i = o.length - 1, b = o[i]; i;)
        for (a = o[--i]; r = a % b; a = b, b = r);
    return b;
}

function cryo_getAspectRatio() {
    var mdc = cryo_mdc([screen.width, screen.height]);

    return (screen.width / mdc) + ":" + (screen.height / mdc);
}

// 29/04/2022 - Tiago Silva - P800 34936;
// A declaração da viriável "defaultDiacriticsRemovalap" foi transferida para o arquivo resource.aspx,
// pois o gulp estava transforlandos os códigos / expressões nas próprias letras, causando um bug

// http://stackoverflow.com/questions/990904/javascript-remove-accents-in-strings
var diacriticsMap = {};
for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
    var letters = defaultDiacriticsRemovalap[i].letters.split("");
    for (var j = 0; j < letters.length; j++) {
        diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
    }
}

// "what?" version ... http://jsperf.com/diacritics/12
function removeDiacritics(str) {
    return str.replace(/[^\u0000-\u007E]/g, function (a) {
        return diacriticsMap[a] || a;
    });
}

function cryo_translateChars(s) {
    return removeDiacritics(s).replace(/[^\w\s]/gi, '');
}

function cryo_closeSideBar() {
    $(".row-workspace>.span8").animate({ width: '99%' }, 350);
    $(".row-workspace>.span4").addClass("hide");
    $(".floating-report").removeClass("hide");
    cryo_writeCookie("sidebar", "close");
    if (typeof filterInBox == 'function') {
        filterInBox();
    }
}
function cryo_openSideBar() {
    $(".row-workspace>.span8").css("width", "");
    $(".row-workspace>.span4").removeClass("hide");
    $(".floating-report").addClass("hide");
    cryo_writeCookie("sidebar", "open");
    if (typeof filterInBox == 'function') {
        filterInBox();
    }
}

function cryo_searchConfirmationNumber() {
    var $img = $(".box-confimation-number .captcha-img");
    var $btn = $(".box-confimation-number .btn-confirmation-search");
    var $codflowexecute = $(".box-confimation-number .input-confirmation-codflowexecute");
    var $confirmation = $(".box-confimation-number .input-confirmation-number");
    var $captcha = $(".box-confimation-number .input-confirmation-captcha");
    var $loading = $(".box-confimation-number .search-loading");
    var $msgnotfound = $(".box-confimation-number .error-notfound");
    var $msgcaptcha = $(".box-confimation-number .error-captcha");
    var $from = $("#From");

    $codflowexecute.width("20%");
    $confirmation.width("20%");
    $captcha.width("20%");
    $img.width("10%");

    $codflowexecute.add($captcha).add($confirmation).keypress(function (event) {
        if (event.which == 13) {
            $btn.trigger("click");
            return false;
        }
    });

    $(".box-confimation-number .input-confirmation-codflowexecute").focus(function () {
        $(this).removeClass("input-error");
    });
    $(".box-confimation-number .input-confirmation-number").focus(function () {
        $(this).removeClass("input-error");
    });

    function resetForm() {
        reloadImg();
        $captcha.val("");
    }

    function reloadImg() {
        $img.attr("src", URL_ROOT + "workbase/wcaptcha.aspx?" + (new Date()).getTime());
        $captcha.val("");
    }

    $img.click(function () {
        reloadImg();
    });

    reloadImg();

    $btn.click(function () {
        $btn.attr("disabled", true);

        $loading.show();
        $msgnotfound.hide();
        $msgcaptcha.hide();

        $codflowexecute.removeClass("input-error");
        $confirmation.removeClass("input-error");
        $captcha.removeClass("input-error");

        if ($codflowexecute.val() == "") {
            $codflowexecute.addClass("input-error");
        }
        if ($confirmation.val() == "") {
            $confirmation.addClass("input-error");
        }
        if ($captcha.val() == "") {
            $captcha.addClass("input-error");
        }

        if ($codflowexecute.val() != "" && $confirmation.val() != "" && $captcha.val() != "") {
            $.getJSON(URL_ROOT + "api/internal/legacy/1.0/execute/confirmationnumber.aspx?e=" + $codflowexecute.val() + "&n=" + $confirmation.val() + "&ct=" + $captcha.val() + "&c=" + $from.val())
                .done(function (doc) {
                    if (doc.success != null) {
                        var url = '..' + doc.success;
                        resetForm();
                        if (disableInterfaceMobileV3 || !clientIsMobile) {
                            cryo_pop(url);
                        } else {
                            app.navigation.goTo(url);
                        }
                    } else if (doc.error != null && doc.error == "CAPTCHA") {
                        cryo_alert($msgcaptcha.text());
                        reloadImg();
                    } else {
                        cryo_alert($msgnotfound.text());
                        resetForm();
                    }
                }).fail(function (a, b, c) {
                    cryo_alert($msgnotfound.text());
                    resetForm();
                }).always(function () {
                    $loading.hide();
                    $btn.removeAttr("disabled");
                });
        } else {
            $loading.hide();
            $btn.removeAttr("disabled");
        }
    });
}

function cryo_alertAjaxError(jqXHR, textStatus, errorThrown) {
    var errorMessage = '';

    if (jqXHR.status != 200) {
        if (jqXHR.responseJSON) {
            if (jqXHR.responseJSON.friendlyMessage) {
                errorMessage += jqXHR.responseJSON.friendlyMessage;
            }
            if (jqXHR.responseJSON.logCode) {
                errorMessage += '\n' + mlLblErrorCode + ': ' + jqXHR.responseJSON.logCode;
            }
        } else if (jqXHR.statusText) {
            errorMessage += jqXHR.statusText;
        } else if (jqXHR.responseText) {
            errorMessage += jqXHR.responseText;
        }
    } else {
        if (textStatus) {
            errorMessage += textStatus;
        }
        if (errorThrown) {
            errorMessage += ' - ' + errorThrown;
        }

        errorMessage = mlMsgAjaxError.replace(/\{\{errorcode\}\}/gi, errorMessage);
    }

    cryo_alert(errorMessage);
}

function cryo_UnderlineAccessKey(selector, onlyTitle) {
    var defaultSelector = 'button[accesskey]';

    function shortcutKeyByBrowser() {
        var shortcutKey = 'Alt + ';

        if (navigator.userAgent.toLowerCase().indexOf('macintosh') > -1) {
            shortcutKey = 'Control + Alt + ';
        } else if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            shortcutKey = 'Alt + Shift + ';
        }

        return shortcutKey;
    }

    function underlineAccessKey(i, o) {
        if ($(o).html().indexOf('<u>') > -1) return;

        if ($(o).attr('title') === undefined) {
            $(o).attr('title', shortcutKeyByBrowser() + $(o).attr('accesskey').toUpperCase());
        }

        var accesskeyIndex;
        accesskeyIndex = cryo_translateChars($(o).html()).toLowerCase().indexOf($(o).attr('accesskey').toLowerCase());

        // has accesskey on label
        if (accesskeyIndex == -1 || onlyTitle === true) return;

        var label, prefix, ak, suffix;
        label = $(o).html();
        prefix = label.substr(0, accesskeyIndex);
        ak = label.substr(accesskeyIndex, 1);
        suffix = label.substr(accesskeyIndex + 1);
        label = prefix + '<u>' + ak + '</u>' + suffix;
        $(o).html(label);
    }

    if (selector !== undefined) {
        $(selector).find(defaultSelector).each(underlineAccessKey);
    } else {
        $(defaultSelector).each(underlineAccessKey);
    }
}

function getSiblings(el, filter) {
    var siblings = [];
    el = el.parentNode.firstChild;
    do { if (!filter || filter(el)) siblings.push(el); } while (el = el.nextSibling);
    return siblings;
}

function isInsideMultipleValueTable(el) {
    var parent = null;
    do {
        parent = (parent || el).parentElement;

        if (parent && parent.nodeName.toLowerCase() === "table" && parent.attributes["mult"] && parent.attributes["mult"].value === "S") {
            return true;
        }
    } while (parent != null)

    return false;
}

function getParentByFilter(el, filter) {
    var parent = null;
    do {
        parent = (parent || el).parentElement;

        if (!filter || filter(parent)) {
            return parent;
        }
    } while (parent != null)

    return null;
}

function autoFillTest() {
    function getRandomArbitrary(min, max) {
        return Math.random() * (max - min) + min;
    }

    function generateRandomString(min, max) {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789 ";

        for (var i = 0; i < getRandomArbitrary(min, max); i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    //Primeiro passo: encontrar campos visíveis

    $("tr[codgroup]").each(function (index, tr) {
        //Campo texto e área de texto
        $(tr).find("input[type=text][mask=''][regexpa='']:not([data-special-type]),textarea[mask=''][regexpa='']:not([data-special-type])").each(function (index2, field) {
            $(field).val(generateRandomString($(field).prop("minlength") || 0, $(field).prop("maxlength") || 3000))
        });

        //Campos com mascara
        $(tr).find("input[type=text][mask]:not([mask=''])").each(function (index2, field) {
            var mask = $(field).attr("mask");
            var matchLetters = mask.match(/DATE|MONEY|NUMBER/gi);

            if ((matchLetters || []).length === 0) {
                $(field).val(mask);
            }
        });
    });
}

var BrowserDetect =
{
    init: function () {
        this.browser = this.searchString(this.dataBrowser) || "Other";
        this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
        if (this.browser == 'Explorer') {
            var msieFound = navigator.userAgent.indexOf('MSIE') > -1;
            this.activedCompabilityMod = msieFound ? ((parseInt(navigator.userAgent.match(/Trident\/(\d+)/)[1], 10) + 4) != parseInt(navigator.userAgent.match(/MSIE (\d+)/)[1])) : false;
        }
    },

    searchString: function (data) {
        for (var i = 0; i < data.length; i++) {
            var dataString = data[i].string;
            this.versionSearchString = data[i].subString;

            if (dataString.indexOf(data[i].subString) != -1) {
                return data[i].identity;
            }
        }
    },

    searchVersion: function (dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index == -1) return;
        var version = parseFloat(dataString.substring(index + this.versionSearchString.length + 1));

        if (BrowserDetect.browser == 'Explorer') {
            switch (version) {
                case 4:
                    version = '8';
                    break;
                case 5:
                    version = '9';
                    break;
                case 6:
                    version = '10';
                    break;
                case 7:
                    version = '11';
                    break;
                default:
                    return;
            }
        }

        return version;
    },

    dataBrowser:
        [
            { string: navigator.userAgent, subString: "Edge", identity: "Edge" },
            { string: navigator.userAgent, subString: "Chrome", identity: "Chrome" },
            { string: navigator.userAgent, subString: "Trident", identity: "Explorer" },
            { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" },
            { string: navigator.userAgent, subString: "Safari", identity: "Safari" },
            { string: navigator.userAgent, subString: "Opera", identity: "Opera" }
        ]
};

$(document).ready(function () {
    BrowserDetect.init();
});

function htmlEncode(value) {
    var result = filterXSS(value);
    return result;
}

function htmlDecode(value) {
    return $('<div/>').html(value).text();
}